import { render } from "./AddressCheck.vue?vue&type=template&id=801e4aa8&scoped=true"
import script from "./AddressCheck.vue?vue&type=script&lang=js"
export * from "./AddressCheck.vue?vue&type=script&lang=js"

import "./AddressCheck.vue?vue&type=style&index=0&id=801e4aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-801e4aa8"]])

export default __exports__